(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }

      // Force collection pages out of persisted dense/zoom-out mode.
      const grid = document.querySelector('results-list [product-grid-view]');
      if (grid && grid.getAttribute('product-grid-view') === 'zoom-out') {
        grid.setAttribute('product-grid-view', 'default');
      }

      const desktopKey = 'product-grid-view-desktop';
      const mobileKey = 'product-grid-view-mobile';
      if (sessionStorage.getItem(desktopKey) === 'zoom-out') {
        sessionStorage.setItem(desktopKey, 'default');
      }
      if (sessionStorage.getItem(mobileKey) === 'zoom-out') {
        sessionStorage.setItem(mobileKey, 'default');
      }

      const kitsMarqueeTrack = document.querySelector('.all-kits-marquee .announcement-marquee__track[id^="AllKitsMarquee-"]');
      if (kitsMarqueeTrack && kitsMarqueeTrack.children.length > 0 && !kitsMarqueeTrack.dataset.cloned) {
        const slides = Array.from(kitsMarqueeTrack.children);
        slides.forEach((slide) => kitsMarqueeTrack.appendChild(slide.cloneNode(true)));
        slides.forEach((slide) => kitsMarqueeTrack.appendChild(slide.cloneNode(true)));
        kitsMarqueeTrack.dataset.cloned = 'true';
      }

      const allProductsContainer = document.querySelector('.product-grid-container--all-products');
      if (allProductsContainer) {
        let revealObserver;
        const getProductItems = () => Array.from(allProductsContainer.querySelectorAll('.product-grid__item'));

        const prepareItemsForReveal = (items) => {
          items.forEach((item, index) => {
            if (item.classList.contains('is-revealed') || item.classList.contains('is-reveal-pending')) return;
            item.style.setProperty('--reveal-delay', `${Math.min(index * 0.04, 0.44)}s`);
            item.classList.add('is-reveal-pending');
            if (revealObserver) {
              revealObserver.observe(item);
            } else {
              item.classList.add('is-revealed');
            }
          });
        };

        if ('IntersectionObserver' in window) {
          revealObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                observer.unobserve(entry.target);
              });
            },
            { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
          );
        }

        prepareItemsForReveal(getProductItems());

        if ('MutationObserver' in window) {
          const mutationObserver = new MutationObserver(() => {
            prepareItemsForReveal(getProductItems());
          });
          mutationObserver.observe(allProductsContainer, { childList: true, subtree: true });
        }
      }
    },
    { once: true }
  );

  // Kit carousel controls
  const kitTrack = document.querySelector('.kit-carousel__track');
  const kitDots = document.querySelectorAll('.kit-carousel__dot');
  const kitPrevButton = document.querySelector('.kit-carousel__prev');
  const kitNextButton = document.querySelector('.kit-carousel__next');
  
  if (kitTrack && kitDots.length > 0) {
    kitDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const items = kitTrack.querySelectorAll('.kit-carousel__item');
        if (items[index]) {
          items[index].scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest', 
            inline: 'start' 
          });
          
          // Update active dot
          kitDots.forEach(d => {
            d.classList.remove('kit-carousel__dot--active');
            d.setAttribute('aria-selected', 'false');
          });
          dot.classList.add('kit-carousel__dot--active');
          dot.setAttribute('aria-selected', 'true');
        }
      });
    });
  }

  if (kitTrack) {
    const getScrollAmount = () => {
      const firstItem = kitTrack.querySelector('.kit-carousel__item');
      const gap = Number.parseFloat(window.getComputedStyle(kitTrack).columnGap || '0') || 0;
      return (firstItem?.getBoundingClientRect().width || kitTrack.clientWidth * 0.85) + gap;
    };

    if (kitPrevButton) {
      kitPrevButton.addEventListener('click', () => {
        kitTrack.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (kitNextButton) {
      kitNextButton.addEventListener('click', () => {
        kitTrack.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
